// 资产表 - 简体中文
export default {
  loading: { text: "拼命加载中" },
  table: {
    totalPrefix: "共计",
    totalSuffix: "条数据",
    download: "下载",
    empty: "暂无数据",
    asset: "资产",
    quantity: "数量",
    priceUSDT: "价格(USDT)",
    valueUSDT: "价值(USDT)",
  },
  tooltips: {
    price: "代币价格为当前币种对应的USDT价格，价格数据每日更新",
    value:
      "代币价值是根据代币价格计算得出，代币价值受多种因素影响实时变化，此处代币价值仅供参考",
  },
  labels: {
    updatedTimePrefix: "更新时间：",
  },
  bigAddress: {
    empty: "当前地址交易数据过度，仅支持输入发送方/接收方地址的条件查询",
  },
  downloadFileName: "数据明细",
};
